import {
  auctionMakeAnOfferRequest,
  privateTreatyMakeAnOfferRequest,
} from '../services/make_an_offer.service';

const AUCTION_MAKE_AN_OFFER_REQUEST = 'AUCTION_MAKE_AN_OFFER_REQUEST';
const AUCTION_MAKE_AN_OFFER_REQUEST_SUCCESS =
  'AUCTION_MAKE_AN_OFFER_REQUEST_SUCCESS';
const AUCTION_MAKE_AN_OFFER_REQUEST_ERROR =
  'AUCTION_MAKE_AN_OFFER_REQUEST_ERROR';
const PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST =
  'PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST';
const PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST_SUCCESS =
  'PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST_SUCCESS';
const PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST_ERROR =
  'PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST_ERROR';

const events = [
  AUCTION_MAKE_AN_OFFER_REQUEST,
  AUCTION_MAKE_AN_OFFER_REQUEST_SUCCESS,
  AUCTION_MAKE_AN_OFFER_REQUEST_ERROR,
  PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST,
  PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST_SUCCESS,
  PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST_ERROR,
];

const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);

  EVENT_BUS.on(
    AUCTION_MAKE_AN_OFFER_REQUEST,
    ({ entityId, csrfToken, values }) => {
      const onError = (error) => {
        EVENT_BUS.dispatch(AUCTION_MAKE_AN_OFFER_REQUEST_ERROR, error);
      };
      const onResponse = () => {
        EVENT_BUS.dispatch(AUCTION_MAKE_AN_OFFER_REQUEST_SUCCESS);
      };

      auctionMakeAnOfferRequest({
        entityId,
        csrfToken,
        values,
        onResponse,
        onError,
      });
    }
  );

  EVENT_BUS.on(
    PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST,
    ({ entityId, csrfToken, values }) => {
      const onError = (error) => {
        EVENT_BUS.dispatch(PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST_ERROR, error);
      };
      const onResponse = () => {
        EVENT_BUS.dispatch(PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST_SUCCESS);
      };

      privateTreatyMakeAnOfferRequest({
        entityId,
        csrfToken,
        values,
        onResponse,
        onError,
      });
    }
  );
};

export const MAKE_AN_OFFER_EVENTS = {
  AUCTION_MAKE_AN_OFFER_REQUEST,
  AUCTION_MAKE_AN_OFFER_REQUEST_SUCCESS,
  AUCTION_MAKE_AN_OFFER_REQUEST_ERROR,
  PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST,
  PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST_SUCCESS,
  PRIVATE_TREATY_MAKE_AN_OFFER_REQUEST_ERROR,
  initializeEventListeners,
};
